import React, { useMemo } from "react";
import { IFanDiscoverDto } from "../../../../../helpers/types";
import VideoPlayer from "../../VideoPlayer";
import SwiperBottomOverlayComponent from "./SwiperBottomOverlayComponent";
import "./index.less";

type SwiperItemProps = {
  discover: IFanDiscoverDto;
  presentationOfSingleCreator: boolean;
  index: number;
  total: number;
  loadMoreDiscovers: () => void;
  globalMuteState: boolean;
  handleMuteChange: (newMuteState: boolean) => void;
  globalShowMuteButton: boolean;
  handleShowMuteButtonChange: (newShowMuteButtonState: boolean) => void;
  shouldShow: boolean;
};

const SwiperItemComponent: React.FC<SwiperItemProps> = ({
  discover,
  presentationOfSingleCreator,
  total,
  index,
  loadMoreDiscovers,
  globalMuteState,
  handleMuteChange,
  globalShowMuteButton,
  handleShowMuteButtonChange,
  shouldShow = false,
}) => {
  // Memoize the thumbnail to prevent recalculations during re-renders
  const thumbnail = useMemo(() => {
    return discover.file.thumbnails.find((thumb: any) => thumb.type === "CLEAR").absolutePath;
  }, [discover.file.thumbnails]);

  // Memoize the VideoPlayer component to prevent unnecessary re-renders
  // Exclude shouldShow from dependencies to prevent re-renders during mute changes
  const videoPlayerComponent = useMemo(() => {
    return (
      <VideoPlayer
        discoverId={discover._id}
        src={discover.file.url}
        thumbnail={thumbnail}
        globalMuted={globalMuteState}
        onMuteChange={handleMuteChange}
        globalShowMuteButton={globalShowMuteButton}
        handleShowMuteButtonChange={handleShowMuteButtonChange}
        index={index}
        total={total}
        loadMoreDiscovers={loadMoreDiscovers}
        presentationOfSingleCreator={presentationOfSingleCreator}
        shouldShow={shouldShow}
      />
    );
  }, [
    discover._id,
    discover.file.url,
    thumbnail,
    globalMuteState,
    handleMuteChange,
    globalShowMuteButton,
    handleShowMuteButtonChange,
    index,
    total,
    loadMoreDiscovers,
    presentationOfSingleCreator,
  ]);

  return (
    <div className="slide-container">
      {videoPlayerComponent}
      {!presentationOfSingleCreator && <SwiperBottomOverlayComponent discover={discover} />}
    </div>
  );
};

export default React.memo(SwiperItemComponent);
